/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import {
  GET_ALL_ACTIVE_USER,
  GET_ALL_DRIVER,
  GET_PROVINCES,
  GET_SENDERS,
  GET_SENDERS_FOR_INVOICE,
  GET_SENDERS_USING_INVENTORY
} from "../../../utils/Endpoints";
import {GetRequest, GetResultObject} from "../../../utils/API"
import _ from 'lodash'

const TYPES = {
  REQUEST_SENDER: "REQUEST_SENDER",
  REQUEST_SENDER_SUCCESS: "REQUEST_SENDER_SUCCESS",
  REQUEST_SENDER_FAILED: "REQUEST_SENDER_FAILED",

  REQUEST_PROVINCE_SUCCESS: "REQUEST_PROVINCE_SUCCESS",

  REQUEST_DRIVER: "REQUEST_DRIVER",
  REQUEST_DRIVER_SUCCESS: "REQUEST_DRIVER_SUCCESS",
  REQUEST_DRIVER_FAILED: "REQUEST_DRIVER_FAILED",

  REQUEST_ACTIVE_USER: "REQUEST_ACTIVE_USER",
  REQUEST_ACTIVE_USER_SUCCESS: "REQUEST_ACTIVE_USER_SUCCESS",
  REQUEST_ACTIVE_USER_FAILED: "REQUEST_ACTIVE_USER_FAILED",
};

const getSender = (inventory) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_SENDER,
      payload: {},
    });

    var param = {};
    var url = GET_SENDERS
    if(inventory == true){
      url = GET_SENDERS_USING_INVENTORY
    }else if(inventory != undefined && inventory.serviceType != undefined && inventory.currentStatus != undefined) {
      url = GET_SENDERS_FOR_INVOICE
      param = {
        "serviceType" : inventory.serviceType,
        "currentStatus" : inventory.currentStatus,
      }
    }
    GetRequest(url, param).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        let senders = []
        datas.map(s => {
          let de = s.delivered;
          let label = de ? `${s.name} (${de})` : `${s.name}`;
          senders.push({label: label, value: s.id})
        })
        return dispatch({
          type: TYPES.REQUEST_SENDER_SUCCESS,
          payload: senders,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_SENDER_FAILED,
        payload: {error},
      });
    });
  }
};




const getDriver = () => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_DRIVER,
      payload: {},
    });

    GetRequest(GET_ALL_DRIVER, {}).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        let senders = []
        datas.map(s => {
          senders.push({label: s.name, value: s.id})
        })
        return dispatch({
          type: TYPES.REQUEST_DRIVER_SUCCESS,
          payload: senders,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_DRIVER_FAILED,
        payload: {error},
      });
    });
  }
};

const getProvinces = () => {
  return (dispatch) => {
    try {
      GetRequest(GET_PROVINCES, {}).then((result) => {
        GetResultObject(result, 'data', 200, datas => {
            let provinces = []
            datas.map(p=>{
              provinces.push({label:p.name, value:p.id})
            })
            return dispatch({
              type: TYPES.REQUEST_PROVINCE_SUCCESS,
              payload:  provinces,
            })
          })
        })
    } catch (error) {
      // console.log(">axios error:", error);
    }
  };
}

const getActiveUser = () => {
  return (dispatch) => {
    try {
      GetRequest(GET_ALL_ACTIVE_USER, {size: 10000, active: true}).then((result) => {
        GetResultObject(result, 'data.content', 200, datas => {
            let users = []
            _.orderBy(datas , function(o) { return o.role }, ['asc']).map(p=>{
              users.push({label:p.name, value:p.id, subLabel: p.role,})
            })
            return dispatch({
              type: TYPES.REQUEST_ACTIVE_USER_SUCCESS,
              payload:  users,
            })
          })
        })
    } catch (error) {
      // console.log(">axios error:", error);
    }
  };
}


export default {
  getActiveUser,
  getProvinces,
  getSender,
  getDriver,
  TYPES,
};
